import { useEffect, useState } from 'react';
import { useStore } from '@nanostores/react';
import { $authFlow, type AuthFlowState } from '../store/auth';
import { EmailForm } from './EmailForm';
import { SignupForm } from './SignupForm';
import { VerificationForm } from './VerificationForm';
import { Finish } from './Finish';

export const AuthFlow = () => {
  const [authState, setAuthState] = useState<AuthFlowState>('email');
  const authFlowStore = useStore($authFlow)

  useEffect(() => {
    // Reset state on mount
    $authFlow.setKey('state', 'email')
  }, []);

  useEffect(() => {
    setAuthState(authFlowStore.state)
  }, [authFlowStore]);

  return (
    <>
      { authState === 'email' && <EmailForm /> }
      { authState === 'signup' && <SignupForm />}
      { authState === 'confirm' && <VerificationForm />}
      { (authState === 'finish' || authState === 'finish-signup') && <Finish />}
    </>
  )
}